import './style.scss'

import React, { Component } from 'react'

import Price from 'components/Price'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import Icon from 'components/UI/Icon'
import svosj from 'img/svosj.svg'
import { freightReason as freightReasonEnum } from 'types/freight'

class CartTotal extends Component {
    render() {
        const { discount, freight, freightReason, total, t } = this.props
        return (
            <div className="cart-total">
                <div className="cart-total--shipping">
                    <span>{t('cartCartTotalFreigh')}</span> <Price amount={freight} />
                </div>
                {discount > 0 && (
                    <div className="cart-total--discount">
                        <span>{t('cartCartTotalDiscount')}</span> <Price amount={discount} />
                    </div>
                )}
                <div className="cart-total--sum">
                    <span>{t('cartCartTotalSum')}</span> <Price amount={total} />
                </div>
                {freightReason === freightReasonEnum.SVOSJ ? (
                    <div className="cart-total--freightReason">
                        <span>
                            <Icon svg={svosj} />
                            {t('cartCartTotalFreightReasonSvosj')}
                        </span>
                    </div>
                ) : null}
            </div>
        )
    }
}

CartTotal.propTypes = {
    discount: PropTypes.number,
    freight: PropTypes.number,
    freightReason: PropTypes.string,
    total: PropTypes.number,
    t: PropTypes.func,
}

export const mapStateToProps = ({ cart, freight }) => {
    return {
        discount: cart.discount,
        freight: freight.freight.amount,
        freightReason: freight.freight.freightReason,
        total: cart.total,
    }
}

export default connect(mapStateToProps)(withTranslation()(CartTotal))
